import { Controller } from '@hotwired/stimulus';

export default class YoutubeEmbedComponentController extends Controller {
  static targets = [
    'player',
    'thumbnail',
    'button',
  ];

  static values = {
    videoId: String,
  };

  initialize() {
    this.setup = this.setup.bind(this);
    this.setupPlayer = this.setupPlayer.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.stopVideo = this.stopVideo.bind(this);
  }

  connect() {
    this.setup();
    this.setupThumbnail();
    this.setupPlayButton();
  }

  setupPlayButton() {
    this.buttonTarget.addEventListener('click', () => this.playVideo());
  }

  setupThumbnail() {
    this.thumbnailTarget.src = `https://img.youtube.com/vi/${this.videoIdValue}/maxresdefault.jpg`;
    this.thumbnailTarget.addEventListener('click', () => this.playVideo());
  }

  setup() {
    if (document.querySelector('[data-youtube-api]') === null) {
      const tag = document.createElement('script');
      tag.dataset.youtubeApi = 'true';

      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = () => {
        this.setupPlayer();
        window.onYouTubeIframeAPIReady = () => {
        };
      };
    } else {
      this.setupPlayer();
    }
  }

  setupPlayer() {
    const classes = this.playerTarget.className;
    const data = this.playerTarget.dataset;

    try {
      // eslint-disable-next-line no-undef
      this.player = new YT.Player(this.playerTarget, {
        height: '390',
        width: '640',
        videoId: this.videoIdValue,
        playerVars: {
          playsinline: 1,
          modestbranding: 1,
          showinfo: 0,
        },
        events: {},
      });
    } catch {
      this.attemptsToSetupPlayer = (this.attemptsToSetupPlayer || 0) + 1;
      if (this.attemptsToSetupPlayer < 10) {
        setTimeout(() => {
          this.setupPlayer();
        }, this.attemptsToSetupPlayer * 500);
      }
    }

    const iframe = this.player.getIframe();
    iframe.className = classes;
    const keys = Object.keys(data);
    for (let i = 0; i < keys.length; i += 1) {
      iframe.dataset[keys[i]] = data[keys[i]];
    }
  }

  playVideo() {
    this.thumbnailTarget.style.display = 'none';
    this.buttonTarget.style.display = 'none';
    this.player.playVideo();
  }

  stopVideo() {
    this.player.stopVideo();
  }
}
